// @flow
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import TopBar from 'containers/header/TopBarContainer';
import TopBarMobile from 'components/header/TopBarMobile';
import MenuContainer from 'containers/header/MenuContainer';
import HeaderMobile from 'containers/header/HeaderMobileContainer';
import { setBodyStyle, resetBodyStyle } from 'utils/bodyUtils';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  location: any
};

type ComponentState = {
  isMobileMenuOpen: boolean
};

class Header extends PureComponent<Props, ComponentState> {
  state: ComponentState = {
    isMobileMenuOpen: false
  };

  onToggleMenu = () => {
    if (this.state.isMobileMenuOpen) this.onCloseMenu();
    else this.onOpenMenu();
  };

  onOpenMenu = () => {
    setBodyStyle({
      position: 'fixed',
      width: '100%',
      top: 0
    });
    this.setState({ isMobileMenuOpen: true });
  };

  onCloseMenu = () => {
    resetBodyStyle();
    this.setState({ isMobileMenuOpen: false });
  };

  render() {
    const { isMobileMenuOpen } = this.state;
    // const { location } = this.props;
    const classNamesHeaderWrapper = dynamicClassName('header__wrapper');
    isMobileMenuOpen && classNamesHeaderWrapper.add('is-visible');
    return (
      <>
        <TopBar />
        <TopBarMobile />
        <header className="header">
          <div className={classNamesHeaderWrapper.build()}>
            <MenuContainer onCloseMenu={this.onCloseMenu} />
          </div>
          <HeaderMobile isMenuOpen={isMobileMenuOpen} onToggleMenu={this.onToggleMenu} onCloseMenu={this.onCloseMenu} />
        </header>
      </>
    );
  }
}

export default withRouter(Header);
